import { LuImage } from "react-icons/lu";
import { LuDownload } from "react-icons/lu";

export default function ImageDownloadCard({ fileName, downloadUrl }) {
  return (
    <div className="max-w-xs cursor-pointer bg-gray-100 dark:bg-gray-800  py-[2px] rounded-sm shadow flex items-center space-x-4">
      {/* <LuImage size={25} className="bg-red-500 text-white p-1 rounded" />   */}
      <div className="flex-grow">
        <img src={downloadUrl} className="w-[100%] h-[200px] object-contain bg-black" />
        {/* <p className="trucate w-[120px] text-[13px] text-gray-900 dark:text-white truncate">{fileName}</p> */}
      </div>
      <a
        href={downloadUrl}
        download
        target="_blank"
        className="p-2 absolute z-40 bg-white/50 hover:bg-white top-3 right-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition"
        title="Download"
      >
        <LuDownload size={15} className="text-gray-700 dark:text-gray-200" />
      </a>
    </div>
  )
}